<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="header__navbar-departments">
    <div class="departments" :class="(deptDropdown) ? 'departments--open' : ''">
      <button class="departments__button" type="button" @click.prevent="deptDropdown = !deptDropdown" v-click-outside="clickedOutside">
        <span class="departments__button-icon">
          <svg width="16px" height="12px">
            <path
              d="M0,7L0,5L16,5L16,7L0,7ZM0,0L16,0L16,2L0,2L0,0ZM12,12L0,12L0,10L12,10L12,12Z"
            />
          </svg>
        </span>
        <span class="departments__button-title">Shop By Category </span>
        <span class="departments__button-arrow">
          <svg width="9px" height="6px">
            <path
              d="M0.2,0.4c0.4-0.4,1-0.5,1.4-0.1l2.9,3l2.9-3c0.4-0.4,1.1-0.4,1.4,0.1c0.3,0.4,0.3,0.9-0.1,1.3L4.5,6L0.3,1.6C-0.1,1.3-0.1,0.7,0.2,0.4z"
            />
          </svg>
        </span>
      </button>
      <div class="departments__menu">
        <div class="departments__arrow"></div>
        <div class="departments__body">
          <ul class="departments__list">
            <li class="departments__list-padding" role="presentation"></li>
            <!-- <li class="departments__item">
              <router-link class="departments__item-link" to="/category"
                >All Categories</router-link
              >
            </li> -->
            <li class="departments__item" v-if="industrial_menus.length > 0">
                <router-link to="/category" class="departments__item-link departments__item-link--catalog-header">
                    INDUSTRY CATALOG
                </router-link>
            </li>
            <li class="departments__list-padding" role="presentation"></li>
            <li class="departments__item " v-for="imenu in industrial_menus" :key="imenu.QGROUP" 
              :class="true ? 'departments__item--submenu--megamenu departments__item--has-submenu': ''"  @mouseover="getChildren(imenu)">
              <a href="#" class="departments__item-link">
                  {{ imenu.QGRDSC }}
                <span class="departments__item-arrow">
                  <svg width="7" height="11">
                    <path d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"/>
                  </svg>
                </span>
              </a>
              <div class="departments__item-menu">
                <div class="megamenu departments__megamenu departments__megamenu--size--nl">
                  <div class="row">
                    <div class="col-12">
                      <ul class="megamenu__links megamenu-links megamenu-links--root" >
                        <li class="megamenu-links__item" v-for="(subcat, i) in imenu.SUBCAT" :key="i" >
                          <!-- <router-link class="megamenu-links__item-link"
                            :to="'/category/2/' + subcat.QGRDSC"
                            >{{ subcat.QCAT }}</router-link> -->
                            <a href="#" class="megamenu-links__item-link" @click.prevent="checkVehicle(imenu.QGROUP, subcat, imenu.QGRDSC, subcat.QCAT)">
                              {{ subcat.QCAT }} 
                            </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <!-- END OF INDUSTRY CATALOG -->

            <!-- start OF SPECIALTY CATALOG -->
            <li class="departments__item">
                <a href='#' class="departments__item-link departments__item-link--catalog-header" @click.prevent="specialty_catalog">
                    {{industrial_menus.length > 0  ? 'SPECIALTY CATALOG' : 'Show all Categories'}}
                </a>
            </li>
            <li class="departments__list-padding" role="presentation"></li>
            <li class="departments__item" v-for="menu in level1" :key="menu.DMCD01" :class="true? 'departments__item--submenu--megamenu departments__item--has-submenu': ''">                
                <a href="#" class="departments__item-link" @click.prevent="categoryClicked(menu.DMCD01, menu.DMCD02, menu.DMCD03)">
                  {{ menu.categoryname }} 
                  <span class="departments__item-arrow" v-if="menu.subcategories.length > 0">
                    <svg width="7" height="11">
                      <path
                        d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"
                      />
                    </svg>
                  </span>
                </a>
              <!-- </router-link> -->
              <div class="departments__item-menu">
                <div class="megamenu departments__megamenu" :class="sizeMenu(menu)" >
                  <div class="row">
                    {{menu.length}}
                    <div v-for="(num, i) in menu.max" :key="i" :class="menu.classCol" >
                      <ul class="megamenu__links megamenu-links megamenu-links--root" >
                        <li
                          class="megamenu-links__item"
                          v-if="menu.hassubs[i] !== undefined"
                          :class="
                            menu.hassubs[i].subcategories.length === 0
                              ? 'hidden'
                              : ' megamenu-links__item--has-submenu'">
                            <a href="#" class="megamenu-links__item-link" @click.prevent="categoryClicked(menu.hassubs[i].DMCD01, menu.hassubs[i].DMCD02, menu.hassubs[i].DMCD03)">
                              {{ menu.hassubs[i].categoryname }}
                            </a>
                          <ul class="megamenu-links">
                            <!-- <li class="megamenu-links__item" v-for="(lvl3, i) in menu.hassubs[i].subcategories" :key="lvl3.DMCD01">
                              <a href="#" class="megamenu-links__item-link" @click.prevent="categoryClicked(lvl3.DMCD01, lvl3.DMCD02, lvl3.DMCD03)">
                                {{ lvl3.categoryname }}
                              </a>
                            </li> -->
                            <cat-3-list-item 
                              v-for="(lvl3, a) in menu.hassubs[i].subcategories"
                              :key="lvl3.DMCD01"
                              :lvl3="lvl3"
                              :i="a"
                              :totalsub="menu.hassubs[i].subcategories.length"
                              @close_menu="close_menu"
                              >
                            </cat-3-list-item>
                            <li class="megamenu-links__item" v-if="menu.hassubs[i].subcategories.length > 5">
                                <a href="#" class="megamenu-links__item-link" style="color: #cb1818" @click.prevent="view_more(menu.hassubs[i].DMCD01, menu.hassubs[i].DMCD02, menu.hassubs[i].DMCD03)">
                                  VIEW MORE
                                </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>

                    <div :class="menu.classCol" >
                      <ul class="megamenu__links megamenu-links megamenu-links--root" >
                        <span style="margin-top: 24px">
                          <!-- <li class="megamenu-links__item"
                            v-for="(nosubcat, indx) in menu.blanksubs"
                            :key="nosubcat.categorycode"
                            :class="indx == 0 ? 'mt-24' : ''">
                            <a href="#" style="color: #cb1818" class="megamenu-links__item-link" @click.prevent="categoryClicked(nosubcat.DMCD01, nosubcat.DMCD02, nosubcat.DMCD03)">
                              {{ menu.hassubs[i].categoryname }}
                            </a>
                          </li> -->
                          <li class="megamenu-links__item" v-if="menu.blanksubs.length > 0">
                            <router-link :to="'/category/1/' + menu.DMCD01" class="megamenu-links__item-link" style="color: #cb1818">
                                VIEW ALL
                            </router-link>
                          </li>
                        </span>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </li>

            <li class="departments__list-padding" role="presentation"></li>
          </ul>
          <div class="departments__menu-container"></div>
        </div>
      </div>
    </div>
  </div>

  <base-dialog title="Invalid Search" @close="closeDialog" :open="searchvalid === false">
    <template #default>
      <p>{{ searchErrorNote }}</p>
    </template>
  </base-dialog>

  <kit-vehicle-dialog @close="openDialog = false" :open="openDialog" :main_category="vehicle_category"></kit-vehicle-dialog>

</template>

<script>
import { mapGetters } from 'vuex';
import axiosvl from "../../../axios/axios-vl.js";
import KitVehicleDialog from '../../pages/kit-group/KitVehicleDialog.vue';
import Cat3ListItem from './Cat3ListItem.vue'

export default {
  components: { KitVehicleDialog, Cat3ListItem},
  props: {
      level1: {
          type: Array,
          required: true
      },

      industrial_menus: {
          type: Array,
          required: true
      },
  },
  data() {
    return {
      categories: [],
      industrial: [],
      isloading: true,
      childURI: null,
      searchvalid: true,

      selectedyear: 0,
      selectedmake: null,
      selectedmodel: null,
      deptDropdown : false,

      vehicle_category: '',
      openDialog: false,
    };
  },
  emits: ['select_vehicle'],
  methods: {
    sizeMenu(menu) {
      let length = menu.hassubs.length;

      let classname = "departments__megamenu--size--nl";
      menu.max = 1;
      if (length == 1 || length == 2) {
        classname = "departments__megamenu--size--nl";
        menu.classCol = "col-6";
        menu.max = 2;
      } else if (length == 3) {
        classname = "departments__megamenu--size--lg";
        menu.classCol = "col-4";
        menu.max = 3;
      } else if (length == 4) {
        classname = "departments__megamenu--size--lg";
        menu.classCol = "col-3";
        menu.max = 8;
      } else if (length > 3) {
        classname = "departments__megamenu--size--xl";
        menu.classCol = "col-1of5";
        menu.max = 10;
      }
      return classname;
    },
    categoryClicked(level1, level2, level3) {
      
      const hasVeh = this.level1.find(l => l.DMCD01 == level1);
      console.log(hasVeh);
      if (hasVeh.DSVEH == 'Y'){
        this.vehicle_category = level1;
        this.openDialog = true;
        return;
      }
      
      this.deptDropdown = false;
      this.isloading = true;

      // const url = 'D15PGMLIB/lansaweb?w=category&r=categoryParts&vlweb=1&part=erp&lang=ENG&_T=1611072351543';
      const partslist_uri = this.$store.getters['api/partslist_uri'];
      axiosvl.post(partslist_uri, {
          // parameters
          webroutine: {
              context: {
              "session-key-method": "hidden",
              },
              fields: {
                  EHCUST: { value: this.$store.getters['customer'] },
                  KL01: { value: level1 },
                  KL02: { value: level2 },
                  KL03: { value: level3 },
                  KL04: { value: "" },
                  KL05: { value: "" },
                  KL06: { value: "" },
                  KL07: { value: "" },
                  KL08: { value: "" },
                  KL09: { value: "" },
                  KL10: { value: "" },
              },
          },
      })
      .then((response) => {
            // let currentcategory = '';
            let uri = '';
            let category_uri = '';
            let currentlevel = 0;
            if (level3 != '') {
              currentlevel = 3;
            } else if (level2 != '') {
              currentlevel = 2;
            } else {
              currentlevel = 1;
            }

          // console.log(currentlevel);

          if (response.data.webroutine.lists.CPARTS.entries.length > 0) {
            category_uri = '/sub-category/';
          } else {
            category_uri = '/category/';
          }

          switch (currentlevel){
              case 1:
                // uri = '/category-search/' + level1;
                uri = category_uri + currentlevel + "/" + level1;
              break;
              case 2:
                uri = category_uri + currentlevel + "/" + level1 + "/" + level2
              break;
              case 3:
                uri = category_uri + currentlevel + "/" + level1 + "/" + level2 + "/" + level3;
              break;
          }

          let ln = 1;
          while (ln <= currentlevel){
              const curr_cat = this.fetchCatDetails(ln, level1, level2, level3);
              uri += '/' + curr_cat.categoryname.replace(/ /g, '-');
              ln++;
          }
        // console.log(uri);
          this.$router.push(uri);
          this.isloading = false;
      })
      .catch(function (error) {
          console.log("error - " + error);
          this.isloading = false;
      });
    },

    getChildren(group) {
        if(group.SUBCAT.length == 0) {
            this.getIndustrialChild(group.QGROUP).then((resdata) => {
              // console.table(resdata.data.webroutine.lists.CATSD.entries);
              let children = [];
              for (const i in resdata.data.webroutine.lists.CATSD.entries) {
                const obj2 = resdata.data.webroutine.lists.CATSD.entries[i];
                children.push({
                    QCAENR: obj2.QCAENR,
                    QCAT: obj2.QCAT,
                    QGRDSC: obj2.QGRDSC,
                    QGRDSCR: obj2.QGRDSCR,
                    QGROUP: obj2.QGROUP,
                    QTYPE: obj2.QTYPE,
                  });
              }
              group.SUBCAT  = children;
            });
            // console.log(group);
        }
    },

    view_more(level1, level2, level3) {

      let uri = '';
      let category_uri = '';
      let currentlevel = 0;
      if (level3 != '') {
        currentlevel = 3;
      } else if (level2 != '') {
        currentlevel = 2;
      } else {
        currentlevel = 1;
      }

      category_uri = '/category/';
      switch (currentlevel){
        case 1:
          // uri = '/category-search/' + level1;
          uri = category_uri + currentlevel + "/" + level1;
        break;
        case 2:
          uri = category_uri + currentlevel + "/" + level1 + "/" + level2
        break;
        case 3:
          uri = category_uri + currentlevel + "/" + level1 + "/" + level2 + "/" + level3;
        break;
      }

      this.$router.push(uri);

    },

    fetchCatDetails(level, DMCD01, DMCD02, DMCD03) {
        const st_categories = this.$store.getters['product/categories'];
        // const level = this.category.categorylevel;

        const cat = st_categories.find((cat) => {
            switch (level){
                case 1:
                    return ((cat.DMCD01 === DMCD01) && (cat.categorylevel === level));
                case 2:
                    return ((cat.DMCD01 === DMCD01) && (cat.DMCD02 === DMCD02) && (cat.categorylevel === level));
                case 3:
                    return ((cat.DMCD01 === DMCD01) && (cat.DMCD02 === DMCD02)  && (cat.DMCD03 === DMCD03) && (cat.categorylevel === level));
            }
        });

        return cat;
    },

    getIndustrialChild(groupID) {
      const sfCatalog = this.$store.getters['storeCatalog'];
      const catpn = this.$store.getters['storeConfigID'];
      // let catpn = '';
      if(sfCatalog.toUpperCase() == 'WHI'){
        this.childURI = this.$store.getters['api/vehicle_categories_uri'];
      }else{
        this.childURI = this.$store.getters['api/vehicle_type_uri'];
      }

      return axiosvl.post(this.childURI, {
        webroutine: {
          context: {
            "session-key-method": "hidden",
          },
          fields: {
            EHCUST: {
              value: this.$store.getters.customer,
            },
            CATPN: {"value": catpn},
            QGROUP: {"value": groupID}
          },
        },
      })
      .then((response) => {
          return response;
      })
      .catch(function (error) {
        console.log("error - " + error);
        // this.isloading = false;
      });
    },

    closeDialog() {
      this.searchvalid = true;
    },

    checkVehicle(qgroup, qtype, group_desc, type_desc){

      const selectedcategories = [];
      const industry_sels = [];
      if(this.storeCatalog == "WHI"){
        selectedcategories.push([qtype.QGRDSC, qgroup]);
        industry_sels.push([type_desc, group_desc]);
      }else{
        selectedcategories.push([qtype.QTYPE, qgroup]);
        industry_sels.push([type_desc, group_desc]);
      }

      // const qgroups = [qgroup];
      // const qtypes = [qtype];

      this.selectedyear = this.$store.getters['vehicle/selectedyear'];
      this.selectedmake = this.$store.getters['vehicle/selectedmake'];
      this.selectedmodel = this.$store.getters['vehicle/selectedmodel'];

      this.$store.dispatch('vehicle/setSelectedCategories', selectedcategories);

      this.$store.dispatch('vehicle/setIndustry_sels', industry_sels);
      // this.$store.dispatch('vehicle/setSelectedGroups', qgroups);
      this.deptDropdown = false;
      if (this.selectedyear === 0 || this.selectedmake === '' || this.selectedmodel === '') {
          this.$emit('select_vehicle');
          return false;
      }else{
          this.$router.push("/search-results");
      }
    },

    clickedOutside(event) {
      if (event.target.closest('.departments__menu') != undefined) {
        if (!event.target.closest('.departments__menu').className.match(/\bdepartments__menu\b/)) {
          // Check if this is a child element of the search button
          if (!event.target.className.match(/\bdepartments__menu\b/)) { 
            // Check if this is not the actual search button
            this.deptDropdown = false;
          }
        }
      } else {
        this.deptDropdown = false;
      }
    },

    specialty_catalog() {
      this.deptDropdown = !this.deptDropdown;
      this.$router.push("/category");
    },

    cancelRemove() {
      this.openDialog = false;
    },

    close_menu() {
      this.deptDropdown = false;
    }
  },
  computed: {
    ...mapGetters([
        "storeCatalog",
    ]),

    primaryCategories() {
      return this.categories.filter((cat) => {
        return cat.categorylevel === 1;
      });
    },

    industrial_category() {
      const industrials = this.$store.getters['product/industrial_categories'];
      // this.industrial_menus = industrial_category;
      // console.log(industrials);
      return industrials;
    },

    searchErrorNote() {
      if (this.storeCatalog === 'WHI') {
        return 'Please select values for Year/Make/Model/Engine to conduct your search.';
      } else if (this.storeCatalog === 'partslink') {
        return 'Please select values for Year/Make/Model to conduct your search.';
      }
      return '';
    }
  },

  updated(){
    // console.log('updated');
    // console.log(this.industrial_menus);
    // const industrials = this.$store.getters['product/industrial_categories'];
    
    // this.industrial = industrials;
    // console.log(this.industrial);
  },

  created() {
    // console.log('created');
    console.log(this.industrial_menus);
  }
};
</script>